import { render, staticRenderFns } from "./cSplashCarousel.vue?vue&type=template&id=58a8d3ba&"
import script from "./cSplashCarousel.vue?vue&type=script&lang=js&"
export * from "./cSplashCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports